const variableSubstitution = (text, variable, value) => {
    const regex = new RegExp(variable, 'g');
    return text.replace(regex, value);
}
  
module.exports = variableSubstitution
  